/* tslint:disable */
/* eslint-disable */
/**
 * Legalscape REST API
 * Internal API for use from web
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CountsByKey } from '../model';
// @ts-ignore
import { FormatCategoriesIdGet200Response } from '../model';
// @ts-ignore
import { FormatCategory } from '../model';
// @ts-ignore
import { FormatSubcategoryWithFiles } from '../model';
// @ts-ignore
import { TotalCount } from '../model';
/**
 * FormatsApi - axios parameter creator
 * @export
 */
export const FormatsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 書式カテゴリの一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formatCategoriesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/format/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 書式カテゴリの詳細を取得する
         * @param {string} id 書式カテゴリの ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formatCategoriesIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('formatCategoriesIdGet', 'id', id)
            const localVarPath = `/format/categories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 書式カテゴリに属する書式サブカテゴリの一覧を取得する
         * @param {string} id 書式カテゴリの ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formatCategoriesIdSubcategoriesGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('formatCategoriesIdSubcategoriesGet', 'id', id)
            const localVarPath = `/format/categories/{id}/subcategories`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 書式ファイルの全数カウント
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileCount: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/format/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 書式ファイルのカテゴリ別カウント
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileCountByCategory: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/format/categories/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FormatsApi - functional programming interface
 * @export
 */
export const FormatsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FormatsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 書式カテゴリの一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formatCategoriesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FormatCategory>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formatCategoriesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 書式カテゴリの詳細を取得する
         * @param {string} id 書式カテゴリの ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formatCategoriesIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormatCategoriesIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formatCategoriesIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 書式カテゴリに属する書式サブカテゴリの一覧を取得する
         * @param {string} id 書式カテゴリの ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formatCategoriesIdSubcategoriesGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FormatSubcategoryWithFiles>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formatCategoriesIdSubcategoriesGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 書式ファイルの全数カウント
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFileCount(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TotalCount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFileCount(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 書式ファイルのカテゴリ別カウント
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFileCountByCategory(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountsByKey>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFileCountByCategory(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FormatsApi - factory interface
 * @export
 */
export const FormatsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FormatsApiFp(configuration)
    return {
        /**
         * 
         * @summary 書式カテゴリの一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formatCategoriesGet(options?: any): AxiosPromise<Array<FormatCategory>> {
            return localVarFp.formatCategoriesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 書式カテゴリの詳細を取得する
         * @param {string} id 書式カテゴリの ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formatCategoriesIdGet(id: string, options?: any): AxiosPromise<FormatCategoriesIdGet200Response> {
            return localVarFp.formatCategoriesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 書式カテゴリに属する書式サブカテゴリの一覧を取得する
         * @param {string} id 書式カテゴリの ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formatCategoriesIdSubcategoriesGet(id: string, options?: any): AxiosPromise<Array<FormatSubcategoryWithFiles>> {
            return localVarFp.formatCategoriesIdSubcategoriesGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 書式ファイルの全数カウント
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileCount(options?: any): AxiosPromise<TotalCount> {
            return localVarFp.getFileCount(options).then((request) => request(axios, basePath));
        },
        /**
         * 書式ファイルのカテゴリ別カウント
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileCountByCategory(options?: any): AxiosPromise<CountsByKey> {
            return localVarFp.getFileCountByCategory(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FormatsApi - interface
 * @export
 * @interface FormatsApi
 */
export interface FormatsApiInterface {
    /**
     * 
     * @summary 書式カテゴリの一覧を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormatsApiInterface
     */
    formatCategoriesGet(options?: AxiosRequestConfig): AxiosPromise<Array<FormatCategory>>;

    /**
     * 
     * @summary 書式カテゴリの詳細を取得する
     * @param {string} id 書式カテゴリの ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormatsApiInterface
     */
    formatCategoriesIdGet(id: string, options?: AxiosRequestConfig): AxiosPromise<FormatCategoriesIdGet200Response>;

    /**
     * 
     * @summary 書式カテゴリに属する書式サブカテゴリの一覧を取得する
     * @param {string} id 書式カテゴリの ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormatsApiInterface
     */
    formatCategoriesIdSubcategoriesGet(id: string, options?: AxiosRequestConfig): AxiosPromise<Array<FormatSubcategoryWithFiles>>;

    /**
     * 書式ファイルの全数カウント
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormatsApiInterface
     */
    getFileCount(options?: AxiosRequestConfig): AxiosPromise<TotalCount>;

    /**
     * 書式ファイルのカテゴリ別カウント
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormatsApiInterface
     */
    getFileCountByCategory(options?: AxiosRequestConfig): AxiosPromise<CountsByKey>;

}

/**
 * FormatsApi - object-oriented interface
 * @export
 * @class FormatsApi
 * @extends {BaseAPI}
 */
export class FormatsApi extends BaseAPI implements FormatsApiInterface {
    /**
     * 
     * @summary 書式カテゴリの一覧を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormatsApi
     */
    public formatCategoriesGet(options?: AxiosRequestConfig) {
        return FormatsApiFp(this.configuration).formatCategoriesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 書式カテゴリの詳細を取得する
     * @param {string} id 書式カテゴリの ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormatsApi
     */
    public formatCategoriesIdGet(id: string, options?: AxiosRequestConfig) {
        return FormatsApiFp(this.configuration).formatCategoriesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 書式カテゴリに属する書式サブカテゴリの一覧を取得する
     * @param {string} id 書式カテゴリの ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormatsApi
     */
    public formatCategoriesIdSubcategoriesGet(id: string, options?: AxiosRequestConfig) {
        return FormatsApiFp(this.configuration).formatCategoriesIdSubcategoriesGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 書式ファイルの全数カウント
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormatsApi
     */
    public getFileCount(options?: AxiosRequestConfig) {
        return FormatsApiFp(this.configuration).getFileCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 書式ファイルのカテゴリ別カウント
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormatsApi
     */
    public getFileCountByCategory(options?: AxiosRequestConfig) {
        return FormatsApiFp(this.configuration).getFileCountByCategory(options).then((request) => request(this.axios, this.basePath));
    }
}
